import { AlertBox } from '@iwoca/orion';

import styles from './CheckDetailsErrors.module.css';

type TProps = {
  hasApplicantDetailsError?: boolean;
  hasCreditCheckError?: boolean;
  hasMissingEquifaxToken?: boolean;
};

const CheckDetailsErrors = ({
  hasApplicantDetailsError,
  hasCreditCheckError,
  hasMissingEquifaxToken,
}: TProps) => {
  if (
    !hasApplicantDetailsError &&
    !hasCreditCheckError &&
    !hasMissingEquifaxToken
  ) {
    return null;
  }

  return (
    <AlertBox variant="failure" className={styles.container}>
      <p className={styles.errorInfo}>
        We were unable to run a soft credit check. To proceed, please ensure
        that the details below are correct:
      </p>
      <ul className={styles.errorList}>
        {hasApplicantDetailsError && (
          <>
            <li>Full name</li>
            <li>Date of birth</li>
          </>
        )}
        {hasMissingEquifaxToken && <li>Your current address</li>}
        {hasCreditCheckError && <li>Address history for the last 6 years</li>}
      </ul>
    </AlertBox>
  );
};

export default CheckDetailsErrors;
